module.exports = __webpack_public_path__ + "img/blue.4851422d.svg";